export default __webpack_public_path__ + "static/media/valmet_logo@3x.fa536008.png";